import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-colorpicker',
  templateUrl: './primeng-colorpicker.component.html',
  styleUrls: ['./primeng-colorpicker.component.scss'],
  standalone: false,
})
export class PrimengColorPickerComponent {
  value = model<string>('');
  disabled = input<boolean>(false);
  inline = input<boolean>(false);

  onChange = output<any>();

  handleChange(event: any) {
    this.onChange.emit(event);
  }
}
